import { useCreatorAccess } from "@/hooks/useCreatorAccess";
import { useSubscription } from "@/hooks/useSubscription";

/** Authoring access never changes consumer library or billing entitlements. */
export function useProgramAuthorAccess() {
  const subscription = useSubscription();
  const creator = useCreatorAccess();
  return {
    hasPremiumAccess: subscription.hasPremiumAccess || creator.canAuthor,
    isLoadingSubscription:
      subscription.isLoadingSubscription ||
      (!subscription.hasPremiumAccess && creator.isLoading),
  };
}
